import { switchAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers } from '@chakra-ui/react'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(switchAnatomy.keys)

const baseStyle = definePartsStyle({
  // define the part you're going to style
  container: {
    // ...
  },
  thumb: {
    // bg: 'red.500',
    
  },
  track: {
    bg: 'gray.500',
    _checked: {
      bg: 'var(--success-green)',
    },
  },
})

export const switchTheme = defineMultiStyleConfig({ baseStyle })